import { useRef } from "react";
import siteData from "./data/site.json";
import type { SiteData } from "./types";
import { Header } from "./components/Header";
import { Timeline, type TimelineHandle } from "./components/Timeline/Timeline";

const site = siteData as unknown as SiteData;

export function App() {
  const timelineRef = useRef<TimelineHandle>(null);
  return (
    <div className="h-screen flex flex-col">
      <Header
        identity={site.identity}
        headline={site.identity.headline}
        onJumpToYear={(ym) => timelineRef.current?.jumpTo(ym)}
      />
      <main className="flex-1 min-h-0">
        <Timeline ref={timelineRef} data={site} />
      </main>
    </div>
  );
}
